import { MyIconHelpers } from "@macashipo/mlib"

import MI_dashboard from "./Types/dashboard"
import MI_search from "./Types/search"
import MI_create from "./Types/create"
import MI_task from "./Types/task"
import MI_create_commu from "./Types/create_commu"
import MI_commu from "./Types/commu"

const List = {
  dashboard: MI_dashboard,
  search: MI_search,
  create: MI_create,
  task: MI_task,
  create_commu: MI_create_commu,
  commu: MI_commu,
}
const MyIconOne = {
  init() {
    MyIconHelpers.addTypesFromListLazy(List)
  },
}

export default MyIconOne
